/**
 * Global application constants
 */
export const APPLICATION_NAME = "Single Skill Database";

export const API_STALE_TIME = {
	THIRTY_SECONDS: 30000,
	ZERO_SECONDS: 0,
};

export const API_CACHE_TIME = {
	ZERO_SECONDS: 0,
};

export const MAX_FILE_SIZE_1_MB = "1MB";

export const MAX_FILE_SIZE_MB = 2;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 2MB in bytes

export const ALLOWED_FILES = ".pdf, .csv, .doc, .docx, .jpg, .jpeg, .png, .webp, .jfif";

export const MAX_FILE_SIZE_TITLE = "2MB";

export const MAX_PAGES_TO_SHOW_FOR_PAGINATION = 5;

// enums/ApplicationStatus.ts
export enum ApplicationStatus {
	NOT_REGISTERED = "NOT_REGISTERED",
	REGISTERED = "REGISTERED",
	COURSES_ADDED = "COURSES_ADDED",
	CHALLAN_GENERATED = "CHALLAN_GENERATED",
	CHALLAN_PAID = "CHALLAN_PAID",
	CHALLAN_UNPAID = "CHALLAN_UNPAID",
	UNPAID = "UNPAID",
	APPROVED = "APPROVED",
	PENDING = "PENDING",
	COMMITTEE_APPROVAL_PENDING = "COMMITTEE_APPROVAL_PENDING",
	DRAFT = "DRAFT",
}
export const LANGUAGES_KEYS = {
	en: "en",
	ur: "ur",
};

export const LANGUAGES_VALUES = {
	en: "🇺🇸 English",
	ur: "🇵🇰 اردو",
};

export const LANGUAGES = {
	english: "English",
	urdu: "Urdu",
};

export const EXPORT_OPTIONS = [
	{ value: "csv", label: "CSV" },
	{ value: "pdf", label: "PDF" },
];

// Course Details Constants
export const COURSE_DETAILS = {
	MIN_SECTIONS: 1,
	MIN_STUDENTS: 1,
	DEFAULT_APPLICATION_ID: 1,
	VALIDATION_DELAY_MS: 100,
	DEBOUNCE_DELAY_MS: 500,
} as const;

// Form Validation Constants
export const FORM_VALIDATION = {
	MIN_SECTIONS: 1,
	MIN_STUDENTS: 1,
	MAX_SECTIONS: 100,
	MAX_STUDENTS_PER_SECTION: 1000,
} as const;

// Application Step Constants
export const APPLICATION_STEPS = {
	COURSE_APPLICATION: 4,
	TRACK_APPLICATION: 5,
	RENEWAL_WITH_CHANGE: 2,
	MAX_INSTITUTE_STEPS: 3,
	INSTITUTE_COMPLETED_THRESHOLD: 4,
	CHALLAN_UNPAID_THRESHOLD: 6,
} as const;

// Network Operators in Pakistan
export const NETWORK_OPERATORS = [
	{ value: "jazz", label: "Jazz" },
	{ value: "warid", label: "Warid" },
	{ value: "ufone", label: "Ufone" },
	{ value: "telenor", label: "Telenor" },
	{ value: "zong", label: "Zong" },
	{ value: "scom", label: "SCOM" },
	{ value: "onic", label: "ONIC" },
] as const;

// Currency and Locale Constants
export const CURRENCY = {
	CODE: "PKR",
	LOCALE: "en-PK",
} as const;

// Date Format Constants
export const DATE_FORMAT = {
	LOCALE: "en-US",
	OPTIONS: {
		year: "numeric",
		month: "long",
		day: "numeric",
	},
	SHORT_OPTIONS: {
		year: "numeric",
		month: "short",
		day: "numeric",
	},
} as const;